"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LocalFile = /*#__PURE__*/function () {
  function LocalFile(source) {
    var _opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0, _classCallCheck2.default)(this, LocalFile);
    (0, _defineProperty2.default)(this, "fdPromise", void 0);
    (0, _defineProperty2.default)(this, "filename", void 0);
    (0, _defineProperty2.default)(this, "fsOpenPromise", void 0);
    (0, _defineProperty2.default)(this, "fsReadPromise", void 0);
    (0, _defineProperty2.default)(this, "fsReadFilePromise", void 0);
    (0, _defineProperty2.default)(this, "fsStatPromise", void 0);
    this.filename = source;
    var utilPromise = Promise.resolve().then(function () {
      return _interopRequireWildcard(require('util'));
    });
    var fsPromise = Promise.resolve().then(function () {
      return _interopRequireWildcard(require('fs'));
    });
    this.fsOpenPromise = Promise.all([utilPromise, fsPromise]).then(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          util = _ref2[0],
          fs = _ref2[1];

      return util.promisify(fs.open);
    });
    this.fsReadPromise = Promise.all([utilPromise, fsPromise]).then(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          util = _ref4[0],
          fs = _ref4[1];

      return util.promisify(fs.read);
    });
    this.fsReadFilePromise = Promise.all([utilPromise, fsPromise]).then(function (_ref5) {
      var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
          util = _ref6[0],
          fs = _ref6[1];

      return util.promisify(fs.readFile);
    });
    this.fsStatPromise = Promise.all([utilPromise, fsPromise]).then(function (_ref7) {
      var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
          util = _ref8[0],
          fs = _ref8[1];

      return util.promisify(fs.stat);
    });
  }

  (0, _createClass2.default)(LocalFile, [{
    key: "getFd",
    value: function () {
      var _getFd = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.fdPromise) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.fsOpenPromise;

              case 3:
                _context.t0 = _context.sent;
                this.fdPromise = (0, _context.t0)(this.filename, 'r');

              case 5:
                return _context.abrupt("return", this.fdPromise);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFd() {
        return _getFd.apply(this, arguments);
      }

      return getFd;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(buffer) {
        var offset,
            length,
            position,
            fetchLength,
            fd,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                offset = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;
                length = _args2.length > 2 ? _args2[2] : undefined;
                position = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 0;
                fetchLength = Math.min(buffer.length - offset, length);
                _context2.next = 6;
                return this.getFd();

              case 6:
                fd = _context2.sent;
                _context2.next = 9;
                return this.fsReadPromise;

              case 9:
                _context2.t0 = _context2.sent;
                return _context2.abrupt("return", (0, _context2.t0)(fd, buffer, offset, fetchLength, position));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read(_x) {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "readFile",
    value: function () {
      var _readFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(options) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fsReadFilePromise;

              case 2:
                _context3.t0 = _context3.sent;
                return _context3.abrupt("return", (0, _context3.t0)(this.filename, options));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function readFile(_x2) {
        return _readFile.apply(this, arguments);
      }

      return readFile;
    }() // todo memoize

  }, {
    key: "stat",
    value: function () {
      var _stat = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.fsStatPromise;

              case 2:
                _context4.t0 = _context4.sent;
                return _context4.abrupt("return", (0, _context4.t0)(this.filename));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function stat() {
        return _stat.apply(this, arguments);
      }

      return stat;
    }()
  }]);
  return LocalFile;
}();

exports.default = LocalFile;